import { render, staticRenderFns } from "./TableWithBigList.vue?vue&type=template&id=94223688&"
import script from "./TableWithBigList.vue?vue&type=script&lang=js&"
export * from "./TableWithBigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports